import { sagwClient } from './clients';
import { CreateDisputeRequest } from './models/dispute';

export function createDispute(request: CreateDisputeRequest) {
  return sagwClient.post('/b2b/dispute/ticket', JSON.stringify(request));
}
